module.exports = __webpack_public_path__ + "static/media/route.639ea0c6.svg";